import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OpportunityNavigationService } from './services/opportunityNavigation.service';

@NgModule({
  imports: [CommonModule],
  providers: [OpportunityNavigationService],
})
export class NavigationModule {}
